import React from 'react';

import EntityInfoCompany from './EntityInfoCompany';
import EntityInfoTopicPage from './EntityInfoTopicPage';
import EntityInfoPublisher from './EntityInfoPublisherPage';

import { EntityInfoContainerProps } from '../types';

const EntityInfoContainer = (props: EntityInfoContainerProps) => {
  if (props.headerContent?.__typename === 'EntityPageTopicPageHeaderContent') {
    return <EntityInfoTopicPage {...props} />;
  }
  if (props.headerContent?.__typename === 'EntityPageCompanyHeaderContent') {
    return <EntityInfoCompany {...props} />;
  }
  if (props.headerContent?.__typename === 'EntityPagePublisherHeaderContent') {
    return <EntityInfoPublisher {...props} />;
  }
  return null;
};

export default EntityInfoContainer;
